import api from './api';
import { fetchPage } from './pagedParams';

const notificationService = {
  getNotifications: async (limit = 50) =>
    (await api.get(`/admin/notifications?limit=${limit}`)).data,
  getUnreadCount: async () => (await api.get('/admin/notifications/unread-count')).data.unreadCount,
  markAsRead: async (id) => (await api.patch(`/admin/notifications/${id}/read`)).data,
  markAllAsRead: async () => api.patch('/admin/notifications/mark-all-read'),

  // Server-side paged list (Spring Page) for the URL-driven DataTable.
  getNotificationsPage: (params) => fetchPage('/admin/notifications/paged', params),

};

export default notificationService;
